<template>
  <section
    :id="content.section_id ? content.section_id : undefined"
    v-observe-visibility="isVisible"
    data-luko-tracking="HighlightBlockSlice"
    :class="[$style.container, isSingleElement && $style.singleElement]"
  >
    <Wrapper :class="$style.inner">
      <article
        v-for="(item, index) in items"
        :key="index"
        :class="[
          { [$style.single]: items.length === 1 },
          { [$style.bigText]: item.big_text },
        ]"
      >
        <Counter
          v-if="item.title"
          :text="item.title"
          :launch="launchCounter"
          :class="$style.counter"
        />
        <PImage v-if="item.icon.url" :image-object="item.icon" />
        <RichText :text-params="item.text" :class="$style.content" />
        <PLink
          v-if="item.cta_title && item.cta_link.url"
          :link-object="item.cta_link"
          is-highlight
          color="white"
        >
          {{ item.cta_title }}
        </PLink>
      </article>
    </Wrapper>
  </section>
</template>

<script>
import RichText from '~/components/RichText'
import PLink from '~/components/PLink'
import PImage from '~/components/PImage'
import Counter from '~/components/Counter'

export default {
  name: 'HighlightBlockSlice',

  components: {
    RichText,
    PLink,
    PImage,
    Counter,
  },

  props: {
    slice: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      launchCounter: false,
    }
  },

  computed: {
    content() {
      return this.slice.primary
    },

    items() {
      return this.slice.items
    },

    isSingleElement() {
      return this.slice.items.length === 2
    },
  },

  methods: {
    isVisible(visible) {
      if (visible) this.launchCounter = visible
    },
  },
}
</script>

<style lang="scss" module>
.container {
  background-color: $bluko-800;
}

.inner {
  display: grid;
  grid-template-columns: 1fr;
  align-items: start;
  justify-items: center;

  padding: 40px 24px;

  @include above(small) {
    grid-template-columns: repeat(2, 1fr);
    gap: 40px;

    padding: 56px 72px;
  }

  @include above(medium) {
    grid-template-columns: repeat(4, 1fr);
  }
}

article {
  width: 100%;
  margin-bottom: 40px;

  text-align: center;

  @include above(small) {
    max-width: 254px;
    margin-bottom: 0;

    text-align: left;
  }

  &:last-child {
    margin-bottom: 0;
  }

  h2 {
    @include typo-title;
    margin-top: 16px;

    color: white;
  }

  h3 {
    @include typo-headline;
    margin-top: 16px;

    color: white;
  }

  p {
    @include typo-body;
    margin-top: 8px;

    color: $bluko-100;
  }

  img {
    width: 100%;
    max-width: 200px;
    height: 100%;
    max-height: 48px;
    object-fit: contain;
    object-position: center;

    @include above(small) {
      object-position: left;
    }
  }

  a {
    margin-top: 8px;

    color: $bluko-100;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    text-decoration: none;
  }

  &.bigText {
    h2 {
      @include typo-extra-title;
    }

    p {
      margin-top: 0;

      @include typo-headline;
      color: $bluko-100;
    }
  }
  .counter {
    @include typo-extra-title;
    color: white;
  }
}

@include above(small) {
  .single {
    display: flex;

    .content {
      display: flex;
      gap: 40px;

      * {
        margin-top: 0;
      }

      h2,
      h3 {
        flex-basis: 100%;
        max-width: 254px;
      }
    }
  }
}
.content {
  p {
  }
}
.singleElement {
  .inner {
    article {
      h2 {
        margin: 0;
      }
      &:last-child {
        max-width: 100%;
        @include above(small) {
          grid-column: span 1;
        }

        @include above(medium) {
          grid-column: span 3;
        }
      }
    }
  }
}
</style>
